import React, { FC } from 'react'

import { MeansOfCommunicationBrContainer } from '../styles/MeanOfCommunicationBrSkeleton.styles'
import { MeanOfCommunicationBrSkeletonView } from './MeanOfCommunicationBrSkeletonView'

export const MeanOfCommunicationBrSkeleton: FC = () => (
  <MeansOfCommunicationBrContainer>
    <MeanOfCommunicationBrSkeletonView />
    <section>
      <MeanOfCommunicationBrSkeletonView />
      <MeanOfCommunicationBrSkeletonView />
      <MeanOfCommunicationBrSkeletonView />
      <MeanOfCommunicationBrSkeletonView />
      <MeanOfCommunicationBrSkeletonView />
    </section>
  </MeansOfCommunicationBrContainer>
)
